import React from "react";
import PropTypes from "prop-types";
import VendaExcelenteDesktop from "./VendaExcelenteDesktop";

function VendaExcelente({ app, config }) {
  return <VendaExcelenteDesktop app={app} config={config} />;
}

VendaExcelente.defaultProps = {
  app: null,
  config: {},
};

VendaExcelente.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default VendaExcelente;
